import { Segment, Input } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { useOrgStore } from "../../store/OrgStore";
import { useContext, useState } from "react";
import UserContext from "../../contexts/UserContext";
import { useAlertsStore } from "../../store/AlertsStore";
import AssetAlert from "./Assets/AssetAlert";

const OrgSiteList = () => {

    const navigate = useNavigate()
    const org = useOrgStore(state => state.org)
    const [search, setSearch] = useState("")
    const { alerts } = useAlertsStore()

    const userContext = useContext(UserContext)

    const orgs =  [... new Set(userContext.userInfo.site_list.map(i => i.owner))].sort()
    const sites = [...new Set(userContext.userInfo.site_list.map(i => i.label))].sort()
    const combined = orgs.concat(sites).sort()
    
    function onClick(i){
        // find if site or org
        let org = orgs.find(o => o === i)
        let site = sites.find(s => s === i)
        if(org){
            navigate(`/organization/${org}`)
        }
        if(site){
            // find org for site
            let user_site = userContext.userInfo.site_list.find(s => s.label === i)
            navigate(`/organization/${user_site.owner}/${site}`)
        }
    }

    let list = orgs
    if(org){
        list = [...new Set(userContext.userInfo.site_list.filter(i => i.owner === org).map(i => i.label))].sort()
    }

    function alerts_view(i){
        let org = orgs.find(o => o === i)
        let sites_objects = []
        if(org){
            // get site list
            sites_objects = userContext.userInfo.site_list.filter(s => s.owner === i)
        } else {
            sites_objects = userContext.userInfo.site_list.filter(s => s.label === i)
        }
        let siteIds = sites_objects.map(s => s.id)
        let site_alerts = alerts.filter(a => siteIds.includes(a.databaseId))
        return site_alerts.map(i => i.searchIndex)
        
    }

    return (
        <>
        <Input type="text" value={search} onChange={(e,d) => setSearch(d.value)} icon="search" fluid/>
        <Segment.Group size='tiny'>
            {search?
                combined.filter(c => c.toLocaleLowerCase().includes(search.toLowerCase())).map(i => {
                    let site_alerts = alerts_view(i)
                    return <Segment style={{"cursor": "pointer"}} onClick={() => onClick(i)} key={i}>
                        <div style={{display: "flex"}}>
                            <div style={{"flexGrow": 1}}>
                                {i}
                            </div>
                            <div style={{"textAlign": "right"}}>
                                {site_alerts.length > 0?<AssetAlert alerts={site_alerts} />: null}
                            </div>
                        </div>
                    </Segment>
                })
            :
                list.map(o => {
                    let site_alerts = alerts_view(o)
                    return <Segment style={{"cursor": "pointer"}} onClick={() => onClick(o)} key={o}>
                        <div style={{display: "flex"}}>
                            <div style={{"flexGrow": 1}}>
                                {o}
                            </div>
                            <div style={{"textAlign": "right"}}>
                                {site_alerts.length > 0?<AssetAlert alerts={site_alerts} />: null}
                            </div>
                        </div>
                        
                    </Segment>
                })
            }
        </Segment.Group>
        </>

    )

}

export default OrgSiteList